export default __webpack_public_path__ + "static/media/sp_comment.f533b1ce.svg";